const MyLoading = (props) => {
  const { className = "" } = props;

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className="text-center">
        <div className="loader mx-auto mb-4"></div>
      </div>
      <style>
        {`
  .loader {
    border: 4px solid rgba(255, 255, 255, 0.2);
    border-left-color: #444;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`}
      </style>
    </div>
  );
};

export default MyLoading;
